import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets';
import { toast } from 'react-toastify';
import { useSystemInfo } from 'services/system-info/useSystemInfo';

const postUpgradeKits = async () => {
  const response = await API.post(
    apiName,
    `${apiBasePath}/kits/upgrade-versions`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.KITS,
        domain: DOMAINS.KITS,
        importance: IMPORTANCE.HIGH,
      },
      context: {},
    },
  );
  return response?.result ?? [];
};

export const useUpgradeKits = () => {
  const { latestSciVersion } = useSystemInfo();
  const queryClient = useQueryClient();
  const kitMutation = useMutation({
    mutationFn: async () => {
      return await postUpgradeKits();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['kits'],
        refetchType: 'all',
      });
      toast.success(
        `All kits will be updated to Version ${latestSciVersion}. You will be emailed when update is complete.`,
      );
    },
  });
  return kitMutation;
};
